import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/home/HomeView.vue";
import YuanAI from "../views/YuanAI/index.vue";
import Digital from "../views/Digital/index.vue";
import CopyAI from "../views/CopyAI/index.vue";
import Travel from "../views/Travel/index.vue";
import Metaverse from "../views/Metaverse/index.vue";
import exhibition from "../views/exhibition/index.vue";
import VR from "../views/VR/index.vue";
import VP from "../views/VP/index.vue";
import bition from "../views/bition/index.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/YuanAI",
    name: "YuanAI",
    component: YuanAI,
  },
    {
    path: "/CopyAI",
    name: "CopyAI",
    component: CopyAI,
  },
  {
    path: "/Digital",
    name: "Digital",
    component: Digital,
  },
  {
    path: "/Travel",
    name: "Travel",
    component: Travel,
  },
  {
    path: "/Metaverse",
    name: "Metaverse",
    component: Metaverse,
  },
  {
    path: "/exhibition",
    name: "exhibition",
    component: exhibition,
  },
  {
    path: "/VR",
    name: "VR",
    component: VR,
  },
  {
    path: "/VP",
    name: "VP",
    component: VP,
  },
  {
    path: "/bition",
    name: "bition",
    component: bition,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
